import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';

export default [
    {
        path: '/market/valentine',
        name: ROUTE_NAME.MARKET_VALENTINE,
        meta: {
            title: '520',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => ({
            component: import(/* webpackChunkName: "market" */ '@/pages/market/valentine.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/market/valentine_card',
        name: ROUTE_NAME.MARKET_VALENTINE_CARD,
        meta: {
            title: '520',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => ({
            component: import(/* webpackChunkName: "market" */ '@/pages/market/valentineCard.vue'),
            loading: Loading,
        }),
    },
];
